<template>
  <section class="py-9 tablet:py-20">
    <div class="w-full desktop:flex" :class="!isDesktop && 'container-wrap'">
      <div :class="isDesktop && 'pl-container-wrap'">
        <div class="slide-width-3 flex h-full flex-col justify-between px-2.5">
          <div>
            <slot name="content" />
          </div>

          <div
            v-if="isShowButton"
            class="hidden desktop:flex desktop:items-center desktop:justify-end desktop:py-2.5"
          >
            <div
              class="flex h-16 items-center overflow-hidden rounded-[64px] bg-gray-600_a15"
            >
              <button
                class="flex h-16 w-16 items-center justify-center rounded-full text-black"
                :class="
                  isBeginning
                    ? 'pointer-events-none opacity-50'
                    : 'hover:bg-gray-600_a25 active:bg-gray-600_a35'
                "
                @click="prev()"
              >
                <IconCaret direction="left" />
              </button>

              <button
                class="flex h-16 w-16 items-center justify-center rounded-full text-black"
                :class="
                  isEnd
                    ? 'pointer-events-none opacity-50'
                    : 'hover:bg-gray-600_a25 active:bg-gray-600_a35'
                "
                @click="next()"
              >
                <IconCaret direction="right" />
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="hidden overflow-hidden desktop:block desktop:flex-1">
        <ClientOnly>
          <div class="relative">
            <swiper-container
              ref="containerRef"
              :slides-per-view="'auto'"
              :slides-per-group="1"
            >
              <swiper-slide
                v-for="item in carouselList"
                :key="item.name"
                class="slide-width-3 h-auto p-2.5"
              >
                <slot name="card" :item="item" />
              </swiper-slide>
            </swiper-container>
          </div>
        </ClientOnly>
      </div>
    </div>
    <div class="container-mobile-extend-wrap desktop:hidden">
      <CarouselBasic :carousel-list="carouselList">
        <template #card="{ item }">
          <slot name="card" :item="item" />
        </template>
      </CarouselBasic>
    </div>
  </section>
</template>

<script setup lang="ts" generic="T extends { name: string }">
  interface IProps {
    carouselList?: T[];
  }

  const props = withDefaults(defineProps<IProps>(), {
    carouselList: () => [],
  });

  const { isDesktop } = useScreen();

  const containerRef = ref<null>(null);

  const slidesPerView = ref<number>(2.4);

  const { instance, isBeginning, isEnd, next, prev } = useSwiper(containerRef, {
    loop: false,
    pagination: {
      enabled: true,
      clickable: true,
    },
  });

  const isShowButton = computed((): boolean => {
    if (isDesktop.value) {
      return props.carouselList.length > slidesPerView.value;
    }
    return false;
  });

  watch(
    () => props.carouselList,
    async () => {
      await nextTick();
      if (!instance.value) return;
      instance.value.updateSlides();
      instance.value.slideTo(0, 0);
      instance.value.updateSlidesClasses();
    }
  );
</script>

<style lang="scss" scoped>
  swiper-container {
    &::part(pagination) {
      @apply hidden;
    }
  }
</style>
